/* OEO header-only checkout shortcut. v2: mobile action row (Teigan-approved design), desktop unchanged. */
(() => {
  if (window.OeoHeaderCheckout) return;
  window.OeoHeaderCheckout = { version: '2026-09-13.2' };

  const root = window.Shopify?.routes?.root || '/';
  const MOBILE = '(max-width: 749px)';
  const style = document.createElement('style');
  style.textContent = [
    '.oeo-header-cart-group{position:relative;display:flex;align-items:center;justify-content:center;flex:0 0 44px;width:44px;height:44px}',
    '.oeo-header-cart-group>a.cart-drawer-button{width:44px;height:44px}',
    '.oeo-header-cart-edit{position:absolute;top:100%;left:50%;transform:translateX(-50%);display:flex;align-items:center;justify-content:center;min-height:24px;white-space:nowrap;font-size:11px;line-height:16px;letter-spacing:0;color:inherit;text-decoration:underline;text-underline-offset:2px}',
    '.oeo-header-cart-edit[hidden]{display:none}',
    '.oeo-cart-action-row{display:none}',
    '@media ' + MOBILE + '{',
    '.oeo-header-cart-edit{display:none}',
    '.oeo-cart-action-row{display:flex;gap:10px;padding:8px 15px 12px;color:inherit}',
    '.oeo-cart-action-row[hidden]{display:none}',
    '.oeo-cart-action-edit{flex:1 1 0;display:flex;align-items:center;justify-content:center;min-height:44px;border:1px solid currentColor;border-radius:4px;background:transparent;color:inherit;font-size:15px;line-height:1.2;text-decoration:none;white-space:nowrap;padding:0 10px}',
    '.oeo-cart-action-checkout{flex:1.35 1 0;display:flex;align-items:center;justify-content:center;gap:12px;min-height:44px;border:1px solid currentColor;border-radius:4px;background:#f5f0e8;color:#1e3a2f;font-size:15px;line-height:1.2;text-decoration:none;white-space:nowrap;padding:0 10px}',
    '}'
  ].join('');
  document.head.append(style);

  function buildRow(header) {
    if (header.parentElement.querySelector('.oeo-cart-action-row')) return header.parentElement.querySelector('.oeo-cart-action-row');
    const row = document.createElement('div');
    row.className = 'oeo-cart-action-row';
    const colorScheme = [...header.classList].find((name) => name.startsWith('color-scheme-'));
    if (colorScheme) row.classList.add(colorScheme);
    row.style.color = window.getComputedStyle(header).color;
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Cart actions');
    const edit = document.createElement('a');
    edit.className = 'oeo-cart-action-edit';
    edit.href = root + 'cart';
    edit.textContent = 'Edit cart';
    const checkout = document.createElement('a');
    checkout.className = 'oeo-cart-action-checkout';
    checkout.href = root + 'checkout';
    checkout.innerHTML = 'Checkout <span aria-hidden="true">\u2192</span>';
    row.append(edit, checkout);
    header.insertAdjacentElement('afterend', row);
    return row;
  }

  function initialise() {
    document.querySelectorAll('header a.cart-drawer-button').forEach((link) => {
      if (link.dataset.oeoCheckout) return;
      link.dataset.oeoCheckout = '2026-09-13.2';
      const group = document.createElement('span');
      group.className = 'oeo-header-cart-group';
      link.before(group);
      group.append(link);
      const edit = document.createElement('a');
      edit.className = 'oeo-header-cart-edit';
      edit.href = root + 'cart';
      edit.textContent = 'Edit cart';
      group.append(edit);
      const header = link.closest('header');
      const row = header ? buildRow(header) : null;
      const badge = link.querySelector('cart-count');
      const paint = () => {
        const hasItems = parseInt(badge?.textContent || '0', 10) > 0;
        edit.hidden = !hasItems;
        if (row) row.hidden = !hasItems;
        link.href = root + (hasItems ? 'checkout' : 'cart');
        link.setAttribute('aria-label', hasItems ? 'Checkout' : 'Open empty cart');
        if (hasItems) {
          link.removeAttribute('aria-controls');
          link.removeAttribute('aria-expanded');
        } else {
          link.setAttribute('aria-controls', 'CartDrawer');
        }
        link.title = hasItems ? 'Checkout' : 'Cart';
      };
      paint();
      if (badge) new MutationObserver(paint).observe(badge, { childList: true, characterData: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);

  let opening = false;
  window.addEventListener('pageshow', () => {
    opening = false;
    document.querySelectorAll('header a.cart-drawer-button, .oeo-cart-action-checkout').forEach((link) => link.removeAttribute('aria-busy'));
  });
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('header a.cart-drawer-button, .oeo-cart-action-checkout');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (opening) return;
    opening = true;
    link.setAttribute('aria-busy', 'true');
    const pendingSelector = 'form[action*="/cart/add"] .btn--loading, cart-items .btn--loading, form[is="cart-discount"] .btn--loading, .oeo-bundle__add[aria-busy="true"]';
    const waitUntil = Date.now() + 15000;
    while (document.querySelector(pendingSelector)) {
      if (Date.now() > waitUntil) {
        opening = false;
        link.removeAttribute('aria-busy');
        window.alert('Your cart is still updating. Please try again in a moment.');
        return;
      }
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
    let navigating = false;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 6000);
    try {
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('Invalid cart');
      if (cart.item_count > 0) {
        navigating = true;
        window.location.assign(root + 'checkout');
      } else {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.onCartRefresh === 'function') {
          await drawer.onCartRefresh({ detail: { open: true } });
          if (!drawer.open) throw new Error('Cart drawer unavailable');
        } else {
          throw new Error('Cart drawer unavailable');
        }
      }
    } catch (_) {
      navigating = true;
      window.location.assign(root + 'cart');
    } finally {
      clearTimeout(timeout);
      if (!navigating) {
        opening = false;
        link.removeAttribute('aria-busy');
      }
    }
  }, true);
})();
